<ngx-spinner></ngx-spinner>

<section class="container-table">
  <div class='row'>
    <div class="col-6">
      <h1 class="fs-2 fw-bold mb-0">Edit Setting</h1>
    </div>
    <div class="col-6">
      <div class="text-end">

      </div>
    </div>
  </div>



</section>
<section class="container-table mt-3">


<div class="row"  *ngFor="let data  of settingData?.riverwards_click">
<div class="col-4">
  <label class="fs-5 fw-bold">RWG CLICKS:  </label>
  <label class="fs-5 fw-bold d-inline"> {{data.value}}</label>
</div>
<!-- <div class="col-4">
  <label class="fs-5 fw-bold">Key:</label>
  {{data.key}}
</div>
<div class="col-4">
  <label class="fs-5 fw-bold">Type:</label>
  {{data.type}}
</div> -->
</div>
</section>
<div *ngIf="sections!=null">
  <form [formGroup]="mainForm" #form="ngForm">

    <div *ngFor="let section of sections; let i = index" class="accordion accordion-flush" id="accordionFlushExample">
      <div class="accordion-item">
        <h2 class="accordion-header" id="{{'flush'+i}}">
          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
            [attr.data-bs-target]="'#' + 'collapse' +i" aria-expanded="false" [attr.aria-controls]="'collapse' +i">
            <div class="plus-minus-toggle"></div>
            {{section.title }}
          </button>
        </h2>
        <div id="{{'collapse' +i}}" class="accordion-collapse collapse" [attr.aria-labelledby]="'flush'+i"
          data-bs-parent="#accordionFlushExample">
          <div class="accordion-body">


          <div class="row">
            <div *ngFor="let field  of settingData[section.key]" class="col-6">


               <div *ngIf="field.image_dimensions == null" class="my-4">
              <label class="my-1">{{field.key| replace:'[_]': ' '| uppercase  }}:</label>
              <mat-form-field class="w-100" appearance="outline">
                <input matInput placeholder="" [formControlName]="field.key"/>
              </mat-form-field>
            </div>
            <div  *ngIf="field.image_dimensions != null">
              <div class="img-field my-4">
                <label class="my-1">{{field.key | replace:'[_]': ' '| uppercase}}:</label>
                <input type="file" (change)="upload($event, field.key)"
                  hidden id="{{field.key+'-field'}}" accept="image/png, image/gif, image/jpeg" />
                <div class="table_image" (click)="triggerClick(field.key+'-field')"
                  [ngClass]="{'replace-img':imageSrc[field.key]!='null'}">
                     <img [src]="_domSanitizer.bypassSecurityTrustUrl(imageSrc[field.key])" class="img_fit"
                    *ngIf="imageSrc[field.key]!='null'   " />
                  <img src="assets/images/no-image-placeholder.png"
                   *ngIf="imageSrc[field.key]=='null' "
                    class="img-fluid" />
                  <div class="text-replace-img" >
                    Replace File
                  </div>
                </div>
                 <small *ngIf="imageSizeError[field.key]" class="text-danger font-14">The file size must not
                  exceed 5MB</small>
              </div>

                  </div>

            </div>
          </div>



            <button type="submit" (click)="openDialog()"  class="btn_primary my-3">Save</button>

          </div>
        </div>
      </div>

          </div>
  </form>
</div>
